var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"amount",class:_vm.className || 'default'},[_c('span',{staticClass:"amount__main"},[_vm._v(_vm._s(_vm.amountMain))]),_c('span',{staticClass:"amount__sub"},[_vm._v("."+_vm._s(_vm.amountRemainder)+" "+_vm._s(_vm.currency))])])
}
var staticRenderFns = []

export { render, staticRenderFns }